
export default {
  '/:auth_mode(signup|signin)': {
    tag: 'page-auth',
  },
  '/password-reset': {
    tag: 'page-password-reset',
  },
  '/record': {
    tag: 'page-record',
  },
  '/report': {
    tag: 'page-report',
  },
  '/projects': {
    tag: 'page-projects',
  },
  '/projects/:id': {
    tag: 'page-projects-single',
  },
  '/settings': {
    tag: 'page-settings',
  },
  // TODO: ワークスペースの概念が決まり次第route変更
  '/workspace/settings': {
    tag: 'page-workspace-settings',
  },
  '/recorder': {
    tag: 'page-recorder',
  },
  '/': {
    tag: 'page-index',
  },
};

